import EmailEntryDecoration from '../../assets/registration/email-entry-decoration.svg'

type DecorativeBlocksProps = {
  className?: string
}

export const DecorativeBlocks = ({ className }: DecorativeBlocksProps) => (
  <EmailEntryDecoration className={className} aria-hidden='true' />
)
